import { FAN_STYLE_OPTIONS, STEP_ORDER } from '../constants/fanStyle';
import i18n from '../../../i18n/i18n';

const FAN_STYLE_OPTION_INDEX_BY_OPTION_ID = new Map<string, number>(
  STEP_ORDER.flatMap((stepKey) =>
    FAN_STYLE_OPTIONS[stepKey].map((optionId, optionIndex) => [optionId, optionIndex] as const)
  )
);

let cachedLanguage: string | undefined;
let cachedOptionIndexByLabel: Map<string, number> | undefined;

const getOptionIndexByLabel = (label: string) => {
  const currentLanguage = i18n.language;

  if (!cachedOptionIndexByLabel || cachedLanguage !== currentLanguage) {
    cachedLanguage = currentLanguage;
    cachedOptionIndexByLabel = new Map<string, number>();

    for (let stepIndex = 0; stepIndex < STEP_ORDER.length; stepIndex += 1) {
      const stepKey = STEP_ORDER[stepIndex];
      if (!stepKey) continue;

      const options = FAN_STYLE_OPTIONS[stepKey];
      for (let optionIndex = 0; optionIndex < options.length; optionIndex += 1) {
        const optionId = options[optionIndex];
        if (!optionId) continue;

        const optionLabel = i18n.t(`FanStyleOptions.${optionId}.label`);
        if (typeof optionLabel === 'string') {
          cachedOptionIndexByLabel.set(optionLabel, optionIndex);
        }
      }
    }
  }

  return cachedOptionIndexByLabel.get(label);
};

/**
 * fanStyle 태그가 속한 옵션 인덱스(optionIndex)에 따라
 * 배경 레이어에 적용할 opacity className을 반환합니다.
 *
 * - 0: 100%
 * - 1: 80%
 * - 2: 60%
 * - 3 이상: 20%
 */
export const getFanStyleTagBackgroundOpacityClassName = (tagName: string) => {
  const optionIndex =
    getOptionIndexByLabel(tagName) ?? FAN_STYLE_OPTION_INDEX_BY_OPTION_ID.get(tagName);

  // 옵션 인덱스(0-based) -> opacity
  // 0: 100%, 1: 80%, 2: 60%, 3 이상: 20%
  if (optionIndex === 0) return 'opacity-100';
  if (optionIndex === 1) return 'opacity-80';
  if (optionIndex === 2) return 'opacity-60';
  if (typeof optionIndex === 'number') return 'opacity-20';

  return 'opacity-100';
};
